import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useMemo, useState } from "react";
import { Spinner } from "../Loading/Spinner";

export default function TableLogs({ data, limit }) {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    if (data && data.length > 0) {
      const sorted = [...data].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setRows(sorted.map((d) => ({ action: d.action, lastAccess: d.createdAt })));
    } else {
      setRows([]);
    }

    setIsLoading(false);
  }, [data]);

  const headerBg = "#90AFC5";
  const zebraEven = "rgba(144, 175, 197, 0.3)";

  const formatDateCompact = (d) =>
    new Date(d).toLocaleString(undefined, {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });

  const sxHead = useMemo(
    () => ({
      backgroundColor: headerBg,
      "& .MuiTableCell-root": {
        fontFamily: "Montserrat",
        color: "#FFF",
        fontWeight: 700,
        padding: "6px 8px",
        fontSize: "0.82rem",
        lineHeight: 1.2,
        whiteSpace: "nowrap",
      },
    }),
    []
  );

  const sxBody = useMemo(
    () => ({
      backgroundColor: "#FFF",

      "& .MuiTableCell-root": {
        fontFamily: "Montserrat",
        color: "rgba(0,0,0,0.8)",
        padding: "6px 8px",
        fontSize: "0.82rem",
        lineHeight: 1.2,
        borderBottomColor: "rgba(0,0,0,0.06)",
      },

      "& .MuiTableRow-root": {
        height: 34,
      },

      "& .MuiTableRow-root:nth-of-type(even)": {
        backgroundColor: zebraEven,
      },
      "& .MuiTableRow-root:nth-of-type(odd)": {
        backgroundColor: "#FFF",
      },

      "& .MuiTableRow-root:nth-of-type(even) td:first-of-type": {
        borderTopLeftRadius: "6px",
        borderBottomLeftRadius: "6px",
      },
      "& .MuiTableRow-root:nth-of-type(even) td:last-of-type": {
        borderTopRightRadius: "6px",
        borderBottomRightRadius: "6px",
      },
    }),
    []
  );

  return (
    <>
      {isLoading && <Spinner />}

      {!isLoading && (
        <Box sx={{ position: "relative", textAlign: "center", p: 1 }}>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: "6px",
              overflow: "hidden",
            }}
          >
            <Table sx={{ width: "100%" }} size="small" aria-label="logs table">
              <TableHead sx={sxHead}>
                <TableRow>
                  <TableCell
                    align="right"
                    sx={{
                      width: 80,
                      whiteSpace: "nowrap",
                      paddingRight: "6px",
                      paddingLeft: "6px",
                    }}
                  >
                    N° sesión
                  </TableCell>
                  <TableCell align="right">Evento</TableCell>
                  <TableCell align="right">{`Últimos ${limit} accesos`}</TableCell>
                </TableRow>
              </TableHead>

              <TableBody sx={sxBody}>
                {rows.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      align="right"
                      sx={{
                        width: 80,
                        whiteSpace: "nowrap",
                        paddingRight: "6px",
                        paddingLeft: "6px",
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                      {row.action === "LOGIN_SUCCESSFUL"
                        ? "Inicio de sesión"
                        : row.action}
                    </TableCell>

                    <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                      {formatDateCompact(row.lastAccess)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
}
